<template>
    <div>
      <h1 class="mb-4 text-2xl leading-none font-700 md:text-3xl lg:text-4xl lg:mb-8">{{ $t(fieldLabel) }}</h1>
        <div v-if="!validVehicles">
            {{ getNoAvailableText() }}
        </div>
        <div v-else-if="loading">
            {{ getLoadingText() }}
        </div>
        <div v-else v-show="carIsAvailable(index) && vehicleHasRate(index)" v-for="(car, index) of cars" :key="index">
          <label :for="CreatePropertyId(fieldLabel, car.vehicle_class.id)" class="flex flex-wrap items-stretch justify-between mb-4 border rounded sm:flex-no-wrap lg:mb-8">
            <input type="radio" v-model="selectedCar" :id="CreatePropertyId(fieldLabel, car.vehicle_class.id)" :name="fieldLabel" :value="car.vehicle_class" class="hidden">
            <div class="w-full sm:w-2/3 lg:w-3/4">

              <div class="flex flex-wrap items-center h-full p-4 lg:flex-no-wrap">
                <div class="w-full lg:w-1/3 md:mb-0">
                  <div class="p-8 md:p-2 lg:p-4" v-show="vehicleHasImages(index)">
                    <figure class="figure ">
                      <img :alt="car.vehicle_class.name" :src="vehicleFirstImage(index)">
                    </figure>
                  </div>
                </div>

                <div class="w-full lg:w-2/3">
                  <div class="py-4 md:px-4 lg:pl-8">
                    <h3 class="mb-2 text-base leading-none font-700 md:text-lg lg:text-xl lg:mb-4">{{car.vehicle_class.name}}</h3>
                    <p class="text-sm leading-relaxed lg:text-base" v-html="vehicleDescription(index)"></p>
                  </div>
                </div>

              </div>

            </div>
            <div class="w-full border-t sm:w-1/3 lg:w-1/4 sm:border-l sm:border-t-0">

              <div class="flex items-center justify-center h-full">
                <div class="max-w-full p-4 text-center">
                  <div class="mb-4">
                    <template v-if="getVehicleDailyRate(index) > 0">
                        <h3 class="block text-lg leading-none font-700 md:text-xl lg:text-2xl">
                            {{getVehicleDailyRate(index) | toCurrency}}
                        </h3>
                        <div class="block text-base leading-none font-700">{{getDayText()}}</div>
                    </template>

                    <p v-show="carAvailableQuantityIsWithinThreshold(index)" class="text-sm leading-relaxed lg:text-base text-status-alert"><strong>{{car.available_quantity.quantity}} {{ getQuantityText(car.available_quantity.quantity)}}</strong></p>
                  </div>

                  <button @click.prevent="rentCar(index)" v-show="vehicleHasRate(index)" class="button button--brand-1">{{ getRentText() }}</button>
                </div>
              </div>
            </div>
          </label>
        </div>
    </div>
</template>

<script>
    import CaagApi from '@/mixins/CaagApi'
    import HtmlPropertyHelper from '@/mixins/HtmlPropertyHelper'
    import DateTimeHelper from '@/mixins/DateTimeHelper'
    import { mapGetters } from 'vuex'

    export default {
        name: 'AvailableCars',
        mixins: [HtmlPropertyHelper, DateTimeHelper, CaagApi],
        props: {
            fieldLabel: String,
            reservation: Object
        },
        computed: {
            fromDateTimeString: function () {
                return this.getDateTimeFormat(this.reservation.pickupDateTime);
            },
            tillDateTimeString: function () {
                return this.getDateTimeFormat(this.reservation.returnDateTime);
            },
            currentCarId: function() {
                if ( this.reservation.car ) {
                    return this.reservation.car.id;
                }
                else {
                    return null;
                }
            },
            selectedCarId: function() {
                if ( this.selectedCar ) {
                    return this.selectedCar.id;
                }
                else {
                    return null;
                }
            },
            validVehicles: function() {
                if ( this.loading ) {
                    return true
                }
                else {
                    let validVehicles = [];
                    if ( this.cars ) {
                        for ( let i = 0; i < this.cars.length; i++ ) {
                            if ( this.carIsAvailable(i) && this.vehicleHasRate(i) ) {
                                validVehicles.push(this.cars[i]);
                            }
                        }
                    }
                    return validVehicles.length > 0
                }
            },
            ...mapGetters([
                'type'
            ]),
        },
        mounted() {
          this.getAvailableCars(this.currentCarId, this.fromDateTimeString, this.tillDateTimeString);
          this.getSeasons(this.fromDateTimeString, this.tillDateTimeString);
        },
        watch: {
            selectedCar: function(val) {
                val.rate = this.getVehicleRateById(val.id);
                this.$emit('changeCar', val);
            }
        },
        methods: {
            getVehicleRateById: function(id) {
                if ( this.season ) {
                    var rate = this.season.rates.find((rate) => {
                        return rate.vehicle_class_id == id;
                    });
                    if ( rate !== undefined ) {
                        return rate;
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            },
            getVehicleRate: function(index) {
                if ( this.season ) {
                    var rate = this.season.rates.find((rate) => {
                        return rate.vehicle_class_id == this.cars[index].vehicle_class.id;
                    });
                    if ( rate !== undefined ) {
                        return rate;
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            },
            vehicleHasRate: function(index) {
                var rate = this.getVehicleRate(index)
                if(this.type == "Dive" && !isNaN(parseFloat(rate.daily_rate.amount))) return true;
                return rate && parseFloat(rate.daily_rate.amount) > 0;
            },
            vehicleHasImages: function(index) {
                if ( this.cars[index] && this.cars[index].vehicle_class && this.cars[index].vehicle_class.images ) {
                    return this.cars[index].vehicle_class.images.length > 0;
                }
                return false
            },
            vehicleFirstImage: function(index) {
                if ( this.vehicleHasImages(index) ) {
                    return this.cars[index].vehicle_class.images[0].public_link;
                }
                else {
                    return null;
                }
            },
            vehicleDescription: function(index) {
                switch( this.$i18n.locale ) {
                    case 'nl': return this.cars[index].vehicle_class.description_for_website.nl ? this.cars[index].vehicle_class.description_for_website.nl : this.cars[index].vehicle_class.description_for_website.en
                    default: return this.cars[index].vehicle_class.description_for_website.en
                }
            },
            getVehicleDailyRate: function (index) {
                var rate = this.getVehicleRate(index);
                if ( rate ) {
                    return parseFloat(rate.daily_rate.amount);
                }
            },
            selectCar: function(index) {
                this.selectedCar = this.cars[index].vehicle_class;
            },
            rentCar: function(index) {
                this.selectCar(index);
                this.selectedCar.rate = this.getVehicleRateById(this.selectedCar.id);
                this.$emit('rentCar', this.selectedCar);
            },
            carIsAvailable: function(index) {
                return this.cars[index].available_quantity.quantity > 0;
            },
            carAvailableQuantityIsWithinThreshold: function(index) {
                return this.cars[index].available_quantity.quantity <= 5;
            },
            getNoAvailableText(){
                if(this.type == 'Scooter') {
                    return this.$t("availableScooters.noAvailableScooters")
                }
                if(this.type == 'Dive') {
                    return this.$t("availableDivingTanks.noAvailableDivingTank")
                }
                if(this.type == 'Eco Wheels') {
                    return this.$t("availableEcoWheels.noNvailableEcoWheels")
                }
                return this.$t("availableCars.noAvailableCars")
            },
            getLoadingText(){
                if(this.type == 'Scooter') {
                    return this.$t("availableScooters.loading")
                }
                if(this.type == 'Dive') {
                    return this.$t("availableDivingTanks.loading")
                }
                if(this.type == 'Eco Wheels') {
                    return this.$t("availableEcoWheels.loading")
                }
                return this.$t("availableCars.loading")
            },
            getDayText(){
                if(this.type == 'Scooter') {
                    return this.$t("availableScooters.day")
                }
                if(this.type == 'Dive') {
                    return this.$t("availableDivingTanks.day")
                }
                if(this.type == 'Eco Wheels') {
                    return this.$t("availableEcoWheels.day")
                }
                return this.$t("availableCars.day")
            },
            getQuantityText(quantity){
                if(this.type == 'Scooter') {
                    return this.$tc("availableScooters.quantityAvailable", quantity)
                }
                if(this.type == 'Dive') {
                    return this.$tc("availableDivingTanks.quantityAvailable", quantity)
                }
                if(this.type == 'Eco Wheels') {
                    return this.$t("availableEcoWheels.quantityAvailable")
                }
                return this.$tc("availableCars.quantityAvailable", quantity)
            },
            getRentText(){
                if(this.type == 'Scooter') {
                    return this.$t("availableScooters.rentScooter")
                }
                if(this.type == 'Dive') {
                    return this.$t("availableDivingTanks.rentDivingTank")
                }
                if(this.type == 'Eco Wheels') {
                    return this.$t("availableEcoWheels.rentEcoWheel")
                }
                return this.$t("availableCars.rentCar")
            },

        }
    }
</script>

<style>
    .vehicleimage {
        width: 100px;
    }
</style>
